
<template>
<!-- Topbar Start -->
<div class="navbar-custom">
    <div class="container-fluid">
        <ul class="list-unstyled topnav-menu float-right mb-0">

            <li class="dropdown d-none d-lg-inline-block">
                <a class="nav-link dropdown-toggle arrow-none waves-effect waves-light" @click="initFullScreen" data-toggle="fullscreen" href="javascript:void(0)">
                    <i class="fe-maximize noti-icon"></i>
                </a>
            </li>

            <notification-menu />

            <profile-drop-down />

        </ul>

        <!-- LOGO -->
        <div class="logo-box">
            <a :href="$store.state.domain" target="_blank" class="logo logo-dark text-center">
                <span class="logo-sm">
                    <img src="/images/logo/logo-sm-dark.png" alt height="24" />
                </span>
                <span class="logo-lg">
                    <img src="/images/logo/logo-dark.png" alt height="20" />
                </span>
            </a>

            <a :href="$store.state.domain" target="_blank" class="logo logo-light text-center">
                <span class="logo-sm">
                    <img src="/images/logo/logo-sm.png" alt height="24" />
                </span>
                <span class="logo-lg">
                    <img src="/images/logo/logo-light.png" alt height="20" />
                </span>
            </a>
        </div>

        <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
            <li>
                <button class="button-menu-mobile waves-effect waves-light" @click="toggleMenu">
                    <i class="fe-menu"></i>
                </button>
            </li>

            <li>
                <!-- Mobile menu toggle (Horizontal Layout)-->
                <a class="navbar-toggle nav-link" data-toggle="collapse" @click="horizonalmenu()" data-target="#topnav-menu-content">
                    <div class="lines">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </a>
                <!-- End mobile menu toggle-->
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</div>
<!-- end Topbar -->
</template>

<script>
import ProfileDropDown      from "./components/ProfileDropDown.vue"
import notificationMenu    from "./components/notificationMenu.vue"

export default {
    components: {
        ProfileDropDown,
        notificationMenu,
      },
    data() {
        return {
        }
    },
    computed: {
        activeUser() {
          return this.$store.state.AppActiveUser
        }
    },
    methods: {
        /**
         * Toggle menu
         */
        toggleMenu() {
            this.$parent.toggleMenu();
        },
        /**
         * Full screen
         */
        initFullScreen() {
            document.body.classList.toggle("fullscreen-enable");
            if (
                !document.fullscreenElement &&
                /* alternative standard method */
                !document.mozFullScreenElement &&
                !document.webkitFullscreenElement
            ) {
                // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(
                        Element.ALLOW_KEYBOARD_INPUT
                    );
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        },
        /**
         * Toggle rightbar
         */
        toggleRightSidebar() {
            this.$parent.toggleRightSidebar();
        },

        /**
         * Horizontal-toggle menu
         */
        horizonalmenu() {
            let element = document.getElementById("topnav-menu-content");
            element.classList.toggle("show");
        },


    },
};
</script>

